import React, { useState } from "react";
import { Space, DatePicker, Select, Input, Col, Row } from "antd";
import {
    USER_ACTION_OPTIONS,
    AUDIT_LOG_SUBJECT_OPTIONS
} from "../../constants/auditLog";

const AdminAuditLogFilters = ({ filters, onFiltersChange }) => {
    const [searchField, setSearchField] = useState("email");

    const handleSearchFieldChange = (value) => {
        setSearchField(value);
        onFiltersChange({
            ...filters,
            email: undefined,
            username: undefined,
        });
    };

    return (
        <Row gutter={[16, 16]}>
            {/* Search */}
            <Col xs={24} sm={12} md={8} lg={6}>
                <Space direction="vertical" size={4} style={{ width: "100%" }}>
                    <span>Search</span>
                    <Input.Search
                        style={{ width: "100%" }}
                        addonBefore={
                            <Select
                                value={searchField}
                                style={{ width: 110 }}
                                onChange={handleSearchFieldChange}
                            >
                                <Select.Option value="email">Email</Select.Option>
                                <Select.Option value="username">Username</Select.Option>
                            </Select>
                        }
                        placeholder="Search"
                        onSearch={(term) =>
                            onFiltersChange({ ...filters, [searchField]: term })
                        }
                    />
                </Space>
            </Col>

            {/* Description */}
            <Col xs={24} sm={12} md={8} lg={6}>
                <Space direction="vertical" size={4} style={{ width: "100%" }}>
                    <span>Description</span>
                    <Select
                        placeholder="ALL"
                        allowClear
                        style={{ width: "100%" }}
                        onChange={(value) =>
                            onFiltersChange({ ...filters, description: value })
                        }
                    >
                        {USER_ACTION_OPTIONS.map((opt) => (
                            <Select.Option key={opt.value} value={opt.value}>
                                {opt.label}
                            </Select.Option>
                        ))}
                    </Select>
                </Space>
            </Col>

            {/* Subject */}
            <Col xs={24} sm={12} md={8} lg={6}>
                <Space direction="vertical" size={4} style={{ width: "100%" }}>
                    <span>Subject</span>
                    <Select
                        placeholder="ALL"
                        allowClear
                        style={{ width: "100%" }}
                        onChange={(value) =>
                            onFiltersChange({ ...filters, subjectType: value })
                        }
                    >
                        {AUDIT_LOG_SUBJECT_OPTIONS.map((opt) => (
                            <Select.Option key={opt.value} value={opt.value}>
                                {opt.label}
                            </Select.Option>
                        ))}
                    </Select>
                </Space>
            </Col>

            {/* Created At */}
            <Col xs={24} sm={24} md={12} lg={6}>
                <Space direction="vertical" size={4} style={{ width: "100%" }}>
                    <span>Created At</span>
                    <DatePicker.RangePicker
                        style={{ width: "100%" }}
                        value={
                            filters.startDate && filters.endDate
                                ? [filters.startDate, filters.endDate]
                                : null
                        }
                        onChange={(dates) =>
                            dates
                                ? onFiltersChange({
                                    ...filters,
                                    startDate: dates[0],
                                    endDate: dates[1],
                                })
                                : onFiltersChange({
                                    ...filters,
                                    startDate: undefined,
                                    endDate: undefined,
                                })
                        }
                    />
                </Space>
            </Col>
        </Row>
    );
};

export default AdminAuditLogFilters;